"use client";

import { Bot } from "lucide-react";
import { useStore } from "@/lib/store";

/**
 * Renders a tiny "🤖 agent" pill next to the avatar of any author who is
 * a bot user. Pass either an authorId (looked up from store) or the bot
 * flag directly.
 */
export function BotBadge({
  authorId,
  className,
  size = 10,
}: {
  authorId: string | null | undefined;
  className?: string;
  size?: number;
}) {
  const isBot = useStore((s) => {
    if (!authorId) return false;
    const u = s.users.find((x) => x.id === authorId);
    if (!u) return false;
    // Synthesized bot emails always use the bot+ prefix on our controlled domain.
    return u.email.startsWith("bot+") || u.email.endsWith("@bots.pauta.dev");
  });

  if (!isBot) return null;
  return (
    <span
      className={`inline-flex items-center gap-0.5 px-1 rounded text-[9px] font-semibold uppercase tracking-wide bg-[var(--accent-bg)] text-[var(--accent)] ${className || ""}`}
      title="Created by an agent"
    >
      <Bot size={size} />
      agent
    </span>
  );
}
